import { render, staticRenderFns } from "./WhatsappMenu.vue?vue&type=template&id=5629f483"
import script from "./WhatsappMenu.vue?vue&type=script&lang=js"
export * from "./WhatsappMenu.vue?vue&type=script&lang=js"
import style0 from "./WhatsappMenu.vue?vue&type=style&index=0&id=5629f483&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports